<template>
  <div class="footer">
    <div class="copyright">
      Copyright
      <a-icon type="copyright" /> {{2021 + newYearMsg}} <span>古力古利版权所有</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalFooter',
  data () {
    return {}
  },
  computed: {
    newYearMsg () {
      if (this.$store.state.thisYear === 2021) {
        return ''
      } else {
        return '-' + this.$store.state.thisYear
      }
    }
  }
}
</script>

<style lang="less" scoped>
.footer {
  padding: 0 16px;
  margin: 48px 0 24px;
  text-align: center;

  .links {
    margin-bottom: 8px;

    a {
      color: rgba(0, 0, 0, 0.45);

      &:hover {
        color: rgba(0, 0, 0, 0.65);
      }

      &:not(:last-child) {
        margin-right: 40px;
      }
    }
  }
  .copyright {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}
</style>
